module.exports = __webpack_public_path__ + "img/help-step-4.cd9c21b1.png";